module.exports = __webpack_public_path__ + "static/media/day22_grid.c0c7ad28.gif";